import React, { useState } from "react";
import Profile from "../assets/profile.png";
import Bag from "../assets/svgs/bag.svg";
import Location from "../assets/svgs/locationFilled.svg";
import Cross from "../assets/svgs/cross.svg";
import Button from "../components/Button";
import RequestSecondOpinionModal from "./RequestSecondOpinionModal";
import { useNavigate } from "react-router-dom";

function ProfileCard({id, name, speciality,profileImage, yearsOfExperience, address }) {
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [showSecondOpinionPopup, setShowSecondOpinionPopup] = useState(false);
  const navigate = useNavigate()

  const handleProfilePopup = () => {
    setShowProfilePopup(!showProfilePopup);
  };

  const handleSecondOpinionPopup = () => {
    // setShowSecondOpinionPopup(!showSecondOpinionPopup);
    const doctor = { id, name, speciality, yearsOfExperience, address, profileImage }
    navigate('/calendar', { state: { doctor } })
  };

  return (
    <div className="rounded-xl border border-neutral20 p-3 flex-shrink-0 cursor-pointer hover:border-primaryBlue60">
      <div className="flex flex-col md:flex-row gap-6 ">
        {/* Profile Image */}
        <div className="w-32 h-32 rounded-full overflow-hidden">
          <img
            src={profileImage}
            alt={`${name}'s profile`}
            className="w-full h-full object-cover"
          />
        </div>

        {/* Doctor's Info */}
        <div className="flex flex-col  flex-1">
          <div>
            <h3 className="text-lg font-bold text-primaryBlue90">{name}</h3>
            <p className="text-sm font-medium text-neutral60">{speciality}</p>
          </div>

          <div className="">
            {/* Years of Experience */}
            <div className="rounded-lg flex items-center gap-3 py-2 justify-start">
              <img
                src={Bag}
                alt="Experience"
                className="w-5 h-5 px-[2px] py-[1px]"
              />
              <span>
                {yearsOfExperience} years
              </span>
            </div>

            {/* Address */}
            <div className="rounded-lg flex items-center gap-3 py-2 justify-start">
              <div className="w-5 h-5 px-[2px] py-[1px]">
              <img
                src={Location}
                alt="Location"
                
              />
              </div>
              <span className=" text-base font-medium text-primaryBlue60 ">
                {address}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      {/* <div className="hidden md:block h-[1px] bg-neutral20 my-4 w-32"></div> */}
      <div className="flex flex-col md:flex-row gap-6 mt-1">
      <Button active={false} text="View Profile" handleClick={handleProfilePopup} />
      <Button text="Book a FREE Second Opinion" handleClick={handleSecondOpinionPopup} />
      </div>
      {/* <div className="mt-4 flex gap-4 justify-center md:justify-start">
        <Button active={false} text="View Profile" handleClick={handleProfilePopup} />
        <Button text="Book a FREE Second Opinion" handleClick={handleSecondOpinionPopup} />
      </div> */}

      {/* Profile Popup */}
      {showProfilePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-lg w-[90%] max-w-lg">
            {/* Header */}
            <div className="relative flex justify-between rounded-t-2xl items-center bg-[#024E73] p-6">
              <div className="flex items-center pl-8">
                <img
                  src={profileImage}
                  alt="Profile"
                  className="w-16 rounded-full border border-primaryBlue60"
                />
                <div className="ml-4">
                  <h2 className="text-lg font-bold text-white">{name}</h2>
                  <p className="text-sm text-white">{speciality}</p>
                </div>
              </div>
              <button
                onClick={handleProfilePopup}
                className="rounded-full bg-neutral30 p-2 absolute top-5 right-5"
              >
                <img src={Cross} className="w-full h-full" />
              </button>
            </div>

            {/* Body */}
            <div className="p-6">
              <div className="flex items-center gap-3">
                <img
                  src={Bag}
                  alt="Experience"
                  className="w-5 h-5 px-[2px] py-[1px]"
                />
                <p className="text-neutral80">{yearsOfExperience} years</p>
              </div>
              <div className="flex items-center gap-3 mt-4">
                <img
                  src={Location}
                  alt="Location"
                  className="w-5 h-5 px-[2px] py-[1px]"
                />
                <p className=" text-primaryBlue60">{address}</p>
              </div>
              <p className="mt-6 text-sm text-neutral80 leading-relaxed">
                Specializing in oral surgery procedures such as wisdom tooth
                extraction, crowns, implants, dentures, and cosmetic treatments.
                This doctor ensures patients achieve both functional and aesthetic
                results with advanced techniques and compassionate care.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Second Opinion Modal */}
      {/* {showSecondOpinionPopup && (
        <RequestSecondOpinionModal
          handleClose={handleSecondOpinionPopup}
          doctor={{
            id,
            profileImage,
            name,
            speciality,
            yearsOfExperience,
            address,
          }}
        />
      )} */}
    </div>
  );
}

export default ProfileCard;
